<template>
  <div
    class="inline-block animate-spin rounded-full border-2 border-gray-300 border-t-blue-600"
    :style="{width: size + 'px', height: size + 'px'}"
    role="status"
    aria-label="Loading"
  ></div>
</template>

<script setup>
defineProps({
  size: {type: Number, default: 20},
})
</script>
